import type { ReactNode } from 'react';
import React from 'react';

import { BUTTON__CONTENT_CLASS } from '../constants';

export const ButtonInner = ({ children }: { children: ReactNode }) => (
  <div className={BUTTON__CONTENT_CLASS}>{children}</div>
);
